import { createSlice } from '@reduxjs/toolkit';
import { IInfoWindow, IPOI } from 'lib/models/vicinityMap.interface';

export interface IVicinityMapState {
  isSideMenuCollapsed: boolean;
  currPOIs?: IPOI[];
  currInfoWindow?: IInfoWindow;
  infoWindowDetails: boolean;
  showStaticMap: boolean;
}

const initialState: IVicinityMapState = {
  isSideMenuCollapsed: window.innerWidth < 576 || window.innerHeight < 576,
  infoWindowDetails: false,
  showStaticMap: false,
};

const vicinityMapSlice = createSlice({
  name: 'vicinityMap',
  initialState,
  // reducer functions define how the state can be updated
  reducers: {
    setIsSideMenuCollapsed: (state, { payload }: { payload: boolean }) => {
      state.isSideMenuCollapsed = payload;
    },
    setCurrPOIs: (state, { payload }: { payload: IPOI[] }) => {
      state.currPOIs = payload;
    },
    setCurrInfoWindow: (state, { payload }: { payload: IInfoWindow | undefined }) => {
      state.currInfoWindow = payload;
      state.infoWindowDetails = false;
    },
    setInfoWindowDetails: (state, { payload }: { payload: boolean }) => {
      state.infoWindowDetails = payload;
    },
    setShowStaticMap: (state, { payload }: { payload: boolean }) => {
      state.showStaticMap = payload;
    },
  },
});

// actions describe something that happens in the application, and then calling dispatch(action(stateChange)) in a component tells the store what happened.
// when action is dispatched the store runs the root reducer function and lets it calculate the new state based on the old state
export const {
  setIsSideMenuCollapsed,
  setCurrPOIs,
  setCurrInfoWindow,
  setInfoWindowDetails,
  setShowStaticMap,
} = vicinityMapSlice.actions;
export default vicinityMapSlice.reducer;
